// extracted by mini-css-extract-plugin
module.exports = {"chartContainer":"total-clients-chart_chartContainer__38fQ9","header":"total-clients-chart_header__ejbF0"};